module.exports = __webpack_public_path__ + "static/media/camera.618e81fe.svg";